"use strict";

import { c as _c } from "react/compiler-runtime";
import { invariant } from '@autoguru/utilities';
import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const contactNumbersContext = /*#__PURE__*/createContext(null);
export const useContactNumbers = () => {
  const $ = _c(1);
  if ($[0] !== "78cfa5366ed6481e8ef0078fcacec3a2da8e8645a506144162a1c2ddc19e43a6") {
    for (let $i = 0; $i < 1; $i += 1) {
      $[$i] = Symbol.for("react.memo_cache_sentinel");
    }
    $[0] = "78cfa5366ed6481e8ef0078fcacec3a2da8e8645a506144162a1c2ddc19e43a6";
  }
  const contextValue = useContext(contactNumbersContext);
  !(contextValue !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, "Please have a  <ContactNumbersProvilder /> set in your tree") : invariant(false) : void 0;
  return contextValue;
};
export const ContactNumbersProvider = t0 => {
  const $ = _c(4);
  if ($[0] !== "78cfa5366ed6481e8ef0078fcacec3a2da8e8645a506144162a1c2ddc19e43a6") {
    for (let $i = 0; $i < 4; $i += 1) {
      $[$i] = Symbol.for("react.memo_cache_sentinel");
    }
    $[0] = "78cfa5366ed6481e8ef0078fcacec3a2da8e8645a506144162a1c2ddc19e43a6";
  }
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      successContactNumber: "07 5612 5347",
      ordersContactNumber: "02 5300 2825",
      agCustomerContactNumber: "1300 655 661",
      wexContactNumber: "1300 319 886",
      ampolContactNumber: "1300 656 014",
      smsFromNumberForTransactional: "0480 018 336"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  t1 = t2;
  const contactNumbersContextValue = t1;
  let t3;
  if ($[2] !== children) {
    t3 = /*#__PURE__*/_jsx(contactNumbersContext.Provider, {
      value: contactNumbersContextValue,
      children: children
    });
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};